import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import useChatbot from "../../provider/chatbot_provider";

const SelectedPolicies = ({ onClick = () => {} }) => {
  const { activePolicies, setActivePolicies } = useChatbot();

  const handleCheckboxChange = (event: any, index: number) => {
    const updatedPolicies = activePolicies?.map((policy: any, i: any) => ({
      ...policy,
      isSelected: i === index, // only the clicked one is selected
    }));
    setActivePolicies(updatedPolicies || null);
    localStorage.setItem("selectedPolicies", JSON.stringify(updatedPolicies));
  };

  return (
    <>
      <Typography sx={{ color: "black", fontSize: "18px" }}>
        Select a policy to know its information
      </Typography>
      <FormGroup sx={{ pb: 1 }}>
        {activePolicies &&
          activePolicies?.map((policy: Record<string, any>, index: number) => {
            return (
              <FormControlLabel
                key={index}
                control={
                  <Checkbox
                    checked={policy.isSelected}
                    onChange={(event: any) =>
                      handleCheckboxChange(event, index)
                    }
                  />
                }
                label={policy.policies}
                sx={{ width: "100%" }}
                componentsProps={{
                  typography: {
                    sx: { fontSize: "0.8rem" },
                  },
                }}
              />
            );
          })}
      </FormGroup>
      <Box sx={{ textAlign: "center", width: "100%", mt: 2 }}>
        <Button sx={{ border: "1px solid gray" }} onClick={onClick}>
          Submit
        </Button>
      </Box>
    </>
  );
};

export default SelectedPolicies;
